import { Autocomplete, TextField } from '@mui/material';

import React from 'react';
import { BookingsFiltersSelectOption, BookingsFiltersWrapper } from './BookingFilters.styled';
import BookingStatusInfo from '../BookingStatusInfo';
import { BookingCardButton } from '../BookingCard/BookingCard.styled';
import { BookingStatus, bookingsFilterOptions, BookingOption } from '../utils';

export interface BookingsFiltersProps {
  selectionMode: boolean;
  setSelectionMode: () => void;
  bookingFilter: BookingOption[] | undefined;
  setBookingFilter: React.Dispatch<React.SetStateAction<BookingOption[] | undefined>>;
}

const BookingsFilters = ({
  selectionMode,
  setSelectionMode,
  bookingFilter,
  setBookingFilter,
}: BookingsFiltersProps) => {
  return (
    <BookingsFiltersWrapper>
      <BookingCardButton
        variant={selectionMode ? 'contained' : 'outlined'}
        onClick={(event) => {
          event.stopPropagation();
          setSelectionMode();
        }}
        sx={{ textTransform: 'none', width: '170px' }}
      >
        {selectionMode ? 'Отмена выбора' : 'Выбрать несколько'}
      </BookingCardButton>
      <Autocomplete
        disableClearable
        disableCloseOnSelect
        multiple
        options={bookingsFilterOptions}
        value={bookingFilter}
        onChange={(e, v) => setBookingFilter(v)}
        renderTags={(elements) => (
          <span style={{ paddingRight: 3, alignItems: 'center', fontSize: 14 }}>
            {/* <BookingStatusInfo
              small
              status={elements[0].value as BookingStatus}
            /> */}
            {`${elements[0].label}${
              elements?.length - 1 > 0 ? ` и ещё ${elements?.length - 1}` : ''
            }`}
          </span>
        )}
        sx={{ width: 170 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Статус'
            variant='standard'
            sx={{ flexGrow: 0, input: { minWidth: '5px !important' } }}
          />
        )}
        renderOption={(props, option) => {
          const { ...optionProps } = props;
          return (
            // @ts-ignore
            <BookingsFiltersSelectOption {...optionProps}>
              <BookingStatusInfo
                small
                status={option.value as BookingStatus}
                //@ts-ignore
                index={props['data-option-index'] as number}
              />
              {option?.label}
            </BookingsFiltersSelectOption>
          );
        }}
      />
    </BookingsFiltersWrapper>
  );
};

export default BookingsFilters;
